import useStoresByDistanceWithInventory from "./use-stores-by-distance-with-inventory.js";
import useStoresByDistanceWithoutInventory from "./use-stores-by-distance-without-inventory.js";
const useGetStoresByDistanceHook = (sku) => sku ? useStoresByDistanceWithInventory : useStoresByDistanceWithoutInventory;
export {
  useGetStoresByDistanceHook as default
};
//# sourceMappingURL=use-get-stores-by-distance-hook.js.map
